<template>
  <div class="d-flex a-center " v-if="isShow">
    <div
      style="text-align:right;padding-right:10px;font-size:0.875rem;"
      :style="{ width: labelWidth / 16 + 'rem' }"
      class="inputspan"
    >
      <span :class="[isRequired ? 'requireField' : '']">
        {{ santakLabel }}
      </span>
    </div>
    <input
      type="text"
      class="input"
      v-model="santakValue"
      :readonly="isReadOnly"
      @blur="blurHandle"
      :style="{ width: width / 16 + 'rem',color:isColor }"
      isShow
    />
  </div>
</template>

<script>
export default {
  name: "santakinput",
  props: {
    santakLabel: {
      type: String,
    },
    field: {
      type: String,
    },
    isReadOnly: {
      // 是否是禁用
      type: Boolean,
      default: false,
    },
    width: {
      type: String | Number,
      default: " 350",
    },
    isRequired: {
      type: Boolean | String,
      default: false,
    },
    isColor: {
      type: String,
      default: "#000000",
    },
    level: {
      // 用来区别当前组件有没有被别的组件包裹起来
      type: String | Number,
      default: 0,
    },
    fieldName: String,
    labelWidth: {
      type: String | Number,
      default: "90",
    },
    defaultValue: "",
    isShow: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    defaultValue: {
      handler: function(newVal) {
        this.santakValue = newVal;
      },
      deep: true,
    },
    santakValue(newval) {
      // console.log(newval);
      // 说明没有被dialog包裹
      if (this.level == 0) {
        if (this.field) {
          this.$parent[this.field][this.fieldName] = newval;
        } else {
          this.$parent[this.fieldName] = newval;
        }
      } else {
        if (this.field) {
          this.$parent.$parent[this.field][this.fieldName] = newval;
        } else {
          // console.log(this.$parent.$parent.orderPerson)
          this.$parent.$parent[this.fieldName] = newval;
        }
      }
    },
  },
  methods: {
    blurHandle(e) {
      this.$emit("blurHandle", this.santakValue);
    },
  },
  data() {
    return {
      santakValue: "",
    };
  },
  mounted() {
    this.santakValue = this.defaultValue ? this.defaultValue : "";
  },
};
</script>

<style scoped lang="less" scoped>
.input {
  border: 1px solid #ccc;
  border-color: #dedede;
  height: 40px;
  color: #000;
  padding-left: 20px;

  border-radius: 4px;
  justify-content: flex-end;
}
.requireField {
  position: relative;
}
.requireField::after {
  content: "*";
  color: #de1e23;
  position: absolute;
  top: 50%;
  left: -0.5rem;
  transform: translateY(-50%);
}
</style>
